import { t } from "@/i18n-js/instance";
import { getFrequencyOptions } from "../DetailsForm/EventTimeLocation/hooks/useRecurringSettings";

interface RecurringFrequencyLabelProps {
  firstLetterCapital?: boolean;
  frequency?: string;
  frequencyFirstLetterCapital?: boolean;
  includeRepeatsOn?: boolean;
  startsAt?: string;
}

export const useRecurringFrequencyLabel = ({
  startsAt,
  frequency,
  firstLetterCapital = true,
  frequencyFirstLetterCapital = false,
  includeRepeatsOn = true,
}: RecurringFrequencyLabelProps) => {
  if (!startsAt || !frequency) {
    return {
      label: "",
    };
  }

  const frequencyOptions = getFrequencyOptions({
    startsAt,
    firstLetterCapital: frequencyFirstLetterCapital,
  });

  const frequencyValue = frequencyOptions.find(f => f.value === frequency);
  if (!frequencyValue) {
    return {
      label: "",
    };
  }

  const repeatsLabel = t(
    `events.recurring.${
      firstLetterCapital ? "frequencies_capital_letter" : "frequencies"
    }.repeats`,
  );

  const label = includeRepeatsOn
    ? `${repeatsLabel} ${frequencyValue.label}`
    : frequencyValue.label;

  return {
    label,
  };
};
